<template>
  <transition name="fadeslide">
    <div class="modal-mask" v-if="!is_loading">
      <div class="modal-wrapper">
        <div class="modal-container" @click.self="$emit('close')">
          <transition name="ListView" mode="out-in">
            <PagedPublicationTemplate
              ref="current_page"
              :publication="publication"
              :show_page="current_page"
              :zoom="zoom"
              :key="current_page"
            />
          </transition>
        </div>
        <div class="_zoom">
          <div>
            <button type="button" :disabled="zoom <= 0.5" @click="zoom -= 0.14">
              <svg class="svg-icon" viewBox="0 0 20 20">
                <line x1="0" y1="10" x2="20" y2="10" fill="none" />
              </svg>
            </button>
            <label @click="zoom = 1" :title="zoom">zoom</label>
            <button type="button" :disabled="zoom >= 2" @click="zoom += 0.14">
              <svg class="svg-icon" viewBox="0 0 20 20">
                <line x1="0" y1="10" x2="20" y2="10" fill="none" />
                <line x1="10" y1="0" x2="10" y2="20" fill="none" />
              </svg>
            </button>
          </div>
        </div>

        <div class="modal--navbar">
          <!-- <div class>
            <div>
              {{ publication.name }}
              <a
                class="button bordered bordered_white spaced"
                target="_blank"
                v-if="publication.is_model"
                :href="link_to_reply"
                >répondre</a
              >
            </div>
          </div> -->
          <div class="modal--navbar--title">
            <h1>documentation : comment fabriquer ce matériel ?</h1>
          </div>

          <div class="_linktoFiche">
            Partager un lien vers cette fiche :<br />
            <qrcode
              value="Hello, World!"
              :options="{ width: 200 }"
              ref="qrcode"
            />
            <a @click="openQRCode" class="button _create_new" target="_blank">
              Ouvrir dans un nouvel onglet
            </a>
          </div>

          <div class="_realisations">
            <div>
              <img
                :src="`${$root.publicPath}pictos/icone_pasApas.svg`"
                width="40"
                height="40"
              />
              <div>
                <label>Pas à pas</label>
                <small>
                  Liste des récits qui décrivent étape par étape comment refaire
                  ce matériel.
                </small>

                <ul>
                  <li
                    v-for="publication in $root.getPublications({
                      template: 'story',
                      follows_model: 'documentation-pas-a-pas',
                      keyword: this.publication.slugFolderName,
                    })"
                    :key="publication.slugFolderName"
                  >
                    <a
                      :href="urlToCheckoutPubli(publication.slugFolderName)"
                      target="_blank"
                    >
                      {{ publication.name }}&nbsp;↗<br />
                    </a>
                    <small>
                      créé
                      <span v-if="publi_authors && publi_authors.length > 0"
                        >par {{ $root.formatListToHuman(publi_authors) }}</span
                      >
                      le {{ $root.formatDateToHuman(publication.date_created) }}
                    </small>
                  </li>
                </ul>

                <a
                  :href="url_to_create_new_step_by_step"
                  class="button _create_new"
                  target="_blank"
                >
                  Créer un récit pas à pas
                </a>
              </div>
            </div>

            <div>
              <img
                :src="`${$root.publicPath}pictos/icone_Recit-libre.svg`"
                width="40"
                height="40"
              />
              <div>
                <label>Récit libre</label>
                <small>
                  Liste des récits qui racontent de manière libre la fabrication
                  de ce matériel.
                </small>

                <ul>
                  <li
                    v-for="publication in $root.getPublications({
                      template: 'story',
                      follows_model: 'documentation-libre',
                      keyword: this.publication.slugFolderName,
                    })"
                    :key="publication.slugFolderName"
                  >
                    <a
                      :href="urlToCheckoutPubli(publication.slugFolderName)"
                      target="_blank"
                    >
                      {{ publication.name }}&nbsp;↗
                    </a>
                    <small>
                      créé
                      <span v-if="publi_authors && publi_authors.length > 0"
                        >par {{ $root.formatListToHuman(publi_authors) }}</span
                      >
                      le {{ $root.formatDateToHuman(publication.date_created) }}
                    </small>
                  </li>
                </ul>

                <a
                  :href="url_to_create_new_free_form"
                  class="button _create_new"
                  target="_blank"
                >
                  Créer un récit libre
                </a>
              </div>
            </div>
          </div>

          <div class="modal--navbar--arrows" v-if="false">
            <div class="_nav_buttons">
              <transition name="fade">
                <button
                  class="_nav_left"
                  v-show="show_buttons"
                  type="button"
                  :disabled="current_page <= 1"
                  @click="current_page = current_page - 1"
                >
                  <svg class="svg-icon" viewBox="0 0 20 20">
                    <path
                      fill="none"
                      d="M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0
	L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109
	c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483
	c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788
	S18.707,9.212,18.271,9.212z"
                    />
                  </svg>
                </button>
              </transition>
              <div class="_page_indicator label">
                page {{ current_page }} / {{ publi_pages.length }}
              </div>

              <transition name="fade">
                <button
                  type="button"
                  v-show="show_buttons"
                  class="_nav_right"
                  :disabled="current_page >= publi_pages.length"
                  @click="current_page = current_page + 1"
                >
                  <svg class="svg-icon" viewBox="0 0 20 20">
                    <path
                      fill="none"
                      d="M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0
	l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109
	c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483
	c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788
	S1.293,9.212,1.729,9.212z"
                    />
                  </svg>
                </button>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <transition name="fade">
        <button
          type="button"
          v-if="show_buttons"
          class="_close_button"
          @click="$emit('close')"
        >
          <svg class="svg-icon" viewBox="0 0 20 20">
            <path
              fill="none"
              d="M11.469,10l7.08-7.08c0.406-0.406,0.406-1.064,0-1.469c-0.406-0.406-1.063-0.406-1.469,0L10,8.53l-7.081-7.08
							c-0.406-0.406-1.064-0.406-1.469,0c-0.406,0.406-0.406,1.063,0,1.469L8.531,10L1.45,17.081c-0.406,0.406-0.406,1.064,0,1.469
							c0.203,0.203,0.469,0.304,0.735,0.304c0.266,0,0.531-0.101,0.735-0.304L10,11.469l7.08,7.081c0.203,0.203,0.469,0.304,0.735,0.304
							c0.267,0,0.532-0.101,0.735-0.304c0.406-0.406,0.406-1.064,0-1.469L11.469,10z"
            />
          </svg>
        </button>
      </transition>
    </div>
  </transition>
</template>
<script>
import PagedPublicationTemplate from "./PagedPublicationTemplate.vue";
export default {
  props: {
    publication: Object,
  },
  components: {
    PagedPublicationTemplate,
  },
  data() {
    return {
      current_page: 1,
      is_loading: true,
      show_buttons: false,
      zoom: 1,
    };
  },
  created() {
    document.body.style.overflow = "hidden";
    document.addEventListener("keyup", this.modalKeyListener);
  },
  mounted() {
    this.$nextTick(() => {
      this.is_loading = false;

      this.$nextTick(() => {
        this.updatePageSizeAccordingToPanel();
      });

      setTimeout(() => (this.show_buttons = true), 120);
    });
  },
  beforeDestroy() {
    document.body.style.overflow = "";
    document.removeEventListener("keyup", this.modalKeyListener);
  },
  watch: {},
  computed: {
    link_to_reply() {
      return (
        this.$root.dodoc_url +
        "_publications/reply/" +
        this.publication.slugFolderName
      );
    },
    url_to_create_new_step_by_step() {
      return `https://dodoc.tierslieuxedu.org/_publications/reply/documentation-pas-a-pas?keyword=${this.publication.slugFolderName}`;
    },
    url_to_create_new_free_form() {
      return `https://dodoc.tierslieuxedu.org/_publications/reply/documentation-libre?keyword=${this.publication.slugFolderName}`;
    },
    model_for_this_publication() {
      if (!this.publication.follows_model) return false;
      return Object.values(this.$root.publications).find(
        (p) =>
          this.publication.template === p.template &&
          p.is_model === true &&
          p.slugFolderName === this.publication.follows_model
      );
    },
    publi_pages() {
      const publi = this.model_for_this_publication
        ? this.model_for_this_publication
        : this.publication;
      return publi.pages;
    },
  },
  methods: {
    modalKeyListener(event) {
      if (event.key === "Escape") {
        this.$emit("close");
      }
    },
    openQRCode(event) {
      // e.target.download = "";
      // a.href = this.$refs.qrcode.$el.toDataURL();

      event.preventDefault();
      var newTab = window.open();
      newTab.document.write(
        `<!DOCTYPE html><body><img src="${this.$refs.qrcode.$el.toDataURL(
          "image/png"
        )}" /></body>`
      );
      newTab.document.close();

      // window.open(this.$refs.qrcode.$el.toDataURL("image/png"), "_blank");
    },
    urlToCheckoutPubli(slug) {
      return `https://dodoc.tierslieuxedu.org/_publications/${slug}`;
    },
    updatePageSizeAccordingToPanel() {
      if (this.$refs.current_page && this.$refs.current_page.$el) {
        const panel_el = this.$refs.current_page.$el;
        const current_page_el = panel_el.querySelector(".m_page");

        this.zoom = (panel_el.offsetWidth * 1) / current_page_el.offsetWidth;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 10000;

  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: rgba(255, 255, 255, 0.97);
  background-color: rgba(252, 252, 255, 1);
  background-color: hsl(240, 100%, 97%);
  background-color: var(--color-green);
  // background-color: #333;
  // background-color: rgba(51, 51, 51, 0.97);

  // transition: all 0.2s ease-out;
}

.modal-wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  height: 100%;
}

.modal--navbar {
  // position: absolute;
  // bottom: 0;
  // width: 100%;
  box-shadow: 0px 0px 10px -5px var(--logo-blue);
  position: relative;
  flex: 0 0 320px;
  background: white;

  > * {
    border-bottom: 2px solid var(--color-green);
  }

  .modal--navbar--title {
    padding: var(--spacing);
    h1 {
      margin: 0;
      font-size: 1em;
    }
  }

  .modal--navbar--arrows {
    // border-top: 2px solid var(--logo-blue);

    display: flex;
    justify-content: space-around;
    align-items: center;
    // background-color: white;

    // background-color: var(--logo-blue);
    // color: white;

    font-weight: 700;
    letter-spacing: 0.02em;
    // font-size: 1.4rem;

    > * {
      margin: calc(var(--spacing) / 2);
      // width: 2em;
      // height: 2em;
    }
  }
}

.modal-container {
  position: relative;
  // width: 300px;
  // margin: 0px auto;
  padding: 50px;
  height: 100%;
  flex: 1 1 480px;
  overflow-y: scroll;
  // padding: 20px 30px;
  // background-color: #fff;
  border-radius: 2px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  // box-shadow: 0px 4px 2px #999;

  &::after {
    content: "";
    display: block;
    position: absolute;
    right: -2rem;
    width: 2rem;
    height: 1px;
  }
}

// button {
//   box-shadow: 0px 0px 10px -5px var(--logo-blue);

//   &:hover,
//   &:active,
//   &:focus {
//     box-shadow: 0px 0px 10px -2px var(--logo-blue);
//   }
// }

._close_button {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  margin: var(--spacing);
  background-color: transparent;

  .svg-icon {
    display: block;
    color: var(--color-black);
  }
}

._nav_buttons {
  // position: absolute;
  // top: 40%;
  width: 100%;
  // height: 100%;

  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  margin: 0;

  background-color: var(--logo-blue);

  @media screen and (max-width: 50rem) {
    // width: auto;
    height: auto;
    top: auto;
    // top: 0;
    // position: relative;
  }

  ._page_indicator {
    // background-color: white;
    // color: var(--logo-blue);
    padding: calc(var(--spacing) / 4) calc(var(--spacing) / 2);
    border-radius: 4px;
  }
}

._nav_left,
._nav_right {
  padding: calc(var(--spacing) / 4);
  margin: calc(var(--spacing) / 2);
  border: 1px solid white;

  @media screen and (max-width: 50rem) {
  }
}

._zoom {
  position: absolute;
  bottom: 1em;
  text-align: center;
  margin: 0;
  // display: flex;
  // align-items: flex-end;
  // justify-content: flex-end;
  margin: 0;
  border-radius: 2em;
  // padding-bottom: 0.5em;
  background: white;
  user-select: none;
  border: 1px solid var(--color-green);
  // border-style: outset;

  > * {
    margin: 0;
    display: flex;
    align-items: center;

    label {
      color: var(--c-black);
      text-transform: lowercase;
      font-weight: 500;
      font-variant: small-caps;
    }

    button {
      display: block;
      // padding: calc(var(--spacing) / 2);
      padding: 8px;
      margin: calc(var(--spacing) / 4);
      // border: 1px solid white;
      background: transparent;
      width: 2.5em;
      height: 2.5em;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;

      svg {
        color: var(--color-black);
        stroke-width: 8px;
      }
    }
  }
}

._linktoFiche {
  padding: var(--spacing);
  font-size: 0.8em;
  text-align: center;

  canvas {
    display: block;
    margin: 0 auto;
  }

  a {
    margin: 0 auto;
    display: inline-block;
  }
}

._realisations {
  > * {
    display: flex;
    flex-flow: row nowrap;

    img {
      margin: var(--spacing);
      margin-right: 0;
    }

    > *:not(img) {
      margin: var(--spacing);
    }

    label {
      display: block;
      margin: 0;
      padding: 0;
      cursor: normal;
      text-transform: uppercase;
      font-weight: 300;
      font-size: 1.4em;
    }
  }
  ul,
  li {
    list-style: none;
    padding: 0;
  }

  li {
    padding: 0.5em;
    border-left: 2px solid rgba(41, 41, 41, 0.1);
    font-size: 0.8em;

    a {
      font-weight: 500;
      color: inherit;
      border-radius: 50%;
    }
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: translateY(5px);
}
</style>
<style lang="scss">
.modal-wrapper {
  .m_pageContainer {
    margin: 0 auto 0;

    &::after {
      content: "";
      display: block;
      width: 50px;
      height: 1px;
      position: absolute;
      left: 100%;
      top: 0;
    }
  }
}
</style>
